import * as React from "react";

const Dot = ({ fill, opacity }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="4"
    height="4"
    fill="none"
    viewBox="0 0 4 4"
    opacity={opacity || '0'}
    className="dot-transition"
  >
    <circle id="dot" cx="2" cy="2" r="2" fill={fill || 'rgba(11, 11, 11, 1)'}></circle>
  </svg>
);

export default Dot;
